import React, { lazy } from 'react'
import { Route } from 'react-router'
import { SubRouter } from '@/router/SubRouter'

const Index = lazy(() => import('./Index'))
const Detail = lazy(() => import('./Detail'))

//	///////////////////////
//	MARK: EXPORTS
/**	Préfixe statique pour la fiche — un segment statique bat toujours `:param` (`01` §15.2). */
export const SafetyActionRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--safety--actions']}>
    <Route path='action/:actionId/*' element={<Detail />} />
    <Route path='*' element={<Index />} />
  </SubRouter>
))
